import React, { useContext, useEffect, useMemo } from 'react';
import { getDataTable } from '../../initData';
import GridComponent from '../../../../widgets/grid/GridComponent/GridComponent';
import T, { t } from '../../../../common/components/T';
import uikit from '../../../../project/uikit/styles';
import Skeleton from '../../../../widgets/plug/Skeleton/Skeleton';
import css from './OfficeRegisters.module.scss';
import classnames from 'classnames';
import Plug from '../../../../widgets/plug/Plug/Plug';
import { LangContext } from '../../../../common/decorators/Language';
import no_last_registers from '../../../../public/src/img/plugs/no_last_registers.svg';
import { useWindowDimensions } from '../../../../common/utils/windowDimensions';

const RenderData = ({ response, setUserData, showUser }) => {
    const { data } = response;
    const { translation } = useContext(LangContext) || {};
    useEffect(() => {
        setUserData(false);
    }, [setUserData, showUser]);
    const width = useWindowDimensions();
    const dataTable = useMemo(() => getDataTable(data, width), [data, width]);

    return !dataTable.tbody?.data?.length ? (
        <div className={css.plugWrapper}>
            <Plug
                plugImg={no_last_registers}
                plugTitle={t('registers_title', 'Последние регистрации', '/office', translation)}
                plugDescription={t(
                    'lastRegisters_stat-plugDescription',
                    'Приглашайте новых партнеров и просматривайте информацию о последних регистрациях в вашей структуре',
                    '/office',
                    translation
                )}
            />
        </div>
    ) : (
        <>
            <div className={classnames(css.cardHeader)} style={{ alignItems: 'flex-start' }}>
                <div>
                    <div className={css.challengeHeader}>
                        <div className={classnames(css.cardTitle, uikit.mr3)}>
                            <p className={css.blockTitle}>
                                <T textName='registers_title_new' defaultStr='Последние приглашения' page='/office' />
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className={css.cardBody}>
                <GridComponent
                    viewThead={dataTable.thead}
                    viewData={dataTable.tbody}
                    gridName='officeLastInvitations'
                    gridStyles={{
                        gridWrapper: { className: css.gridWrapper },
                        tableWrapper: {
                            wrapper: css.orderTableWrapper,
                            table: css.orderTable
                        },
                        contacts: {
                            td: {
                                className: css.contactsTd
                            }
                        },
                        0: {
                            th: {
                                className: css.w530
                            }
                        },
                        1: {
                            th: {
                                className: css.w247
                            }
                        },
                        2: {
                            th: {
                                className: css.w247
                            }
                        },
                        3: {
                            th: {
                                className: css.w248
                            }
                        },
                        4: {
                            th: {
                                className: css.w204
                            }
                        }
                    }}
                    sticky={{
                        rightStickyColumnName: 'contacts'
                    }}
                />
            </div>
        </>
    );
};
const OfficeRegisters = (props) => {
    return (
        <div className={css.row}>
            <div className={classnames(css.fullWidth)}>
                <div className={css.card}>
                    <Skeleton
                        url={'/api/v1/user/marketing/last-invitations'}
                        Component={RenderData}
                        componentProps={props}
                        wrapperStyles={css.cardBody}
                        lazy={true}
                        elements={[
                            { row: [20], items: ['title'] },
                            {
                                type: 'table',
                                size: { rows: 5, columns: 4 }
                            }
                        ]}
                    />
                </div>
            </div>
        </div>
    );
};
export default OfficeRegisters;
